import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { FileText, Trophy, RotateCcw, Play } from "lucide-react";

export default function SeriesTests() {
  const { productId } = useParams();
  const nav = useNavigate();
  const [tests, setTests] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/student/products/${productId}/tests`).then((r) => setTests(r.data)).catch((e) => setErr("You don't have access to this test series."));
  }, [productId]);

  if (err) return <div className="card-surface p-8 text-center text-content-secondary">{err} <Link to="/pricing" className="text-ember">Browse</Link></div>;
  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Tests</h1>
      <div className="space-y-3">
        {tests.map((t) => (
          <div key={t.id} className="card-surface p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid={`series-test-${t.id}`}>
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-content-muted" />
              <div>
                <div className="text-sm font-medium">{t.name}</div>
                <div className="text-xs text-content-muted">{t.total_questions} questions • {t.duration_minutes} min • {t.total_marks} marks</div>
                {t.last_attempt && <div className="text-xs text-emerald-400 mt-1">Last score: {t.last_attempt.score}/{t.last_attempt.total_marks} ({t.last_attempt.percentage}%)</div>}
              </div>
            </div>
            <div className="flex gap-2">
              {t.last_attempt_id && (
                <Button asChild size="sm" variant="outline" className="border-line rounded-full"><Link to={`/result/${t.last_attempt_id}`}><Trophy className="w-3.5 h-3.5 mr-1" /> Result</Link></Button>
              )}
              {t.in_progress_id ? (
                <Button asChild size="sm" className="btn-ember rounded-full"><Link to={`/test/${t.id}/attempt`}><Play className="w-3.5 h-3.5 mr-1" /> Resume</Link></Button>
              ) : (
                <Button asChild size="sm" className="btn-ember rounded-full"><Link to={`/test/${t.id}/instructions`}>{t.last_attempt_id ? <><RotateCcw className="w-3.5 h-3.5 mr-1" /> Reattempt</> : "Start"}</Link></Button>
              )}
            </div>
          </div>
        ))}
        {tests.length === 0 && <div className="card-surface p-8 text-center text-content-muted">No tests in this series yet.</div>}
      </div>
    </div>
  );
}
